<template>
  <footer>
    <div class="container mx-auto px-8">
      <div
        class="bg-white border mb-24 px-[3.2rem] py-[2.3rem] rounded-[1.2rem] border-white"
      >
        <img src="@/assets/images/logo.png" alt="Logo" class="md:w-1/5 logo" />
        <p style="font-size: 11px; color: #b0b8c8; margin-top: 8px">
          El primer ecosistema digital para la salud integrativa
        </p>
        <div class="md:flex md:flex-wrap">
          <div class="md:w-1/5 pr-4 pl-4 pr-4 pl-4">
            <div class="footer_item">
              <ul>
                <li>
                  <a href="#">{{ $t("About us") }}</a>
                </li>
                <li>
                  <a href="https://wa.me/+34649890875">{{ $t("Contact") }}</a>
                </li>
                <li>
                  <a href="#">{{ $t("Privacy policy") }}</a>
                </li>
                <li>
                  <a href="#">{{ $t("Terms & conditions") }}</a>
                </li>
                <li>
                  <a href="/aviso-legal">{{ $t("Legal notice") }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="md:w-1/5 pr-4 pl-4 pr-4 pl-4">
            <div class="footer_item">
              <ul>
                <li>
                  <a href="/search">{{ $t("Search a Professional") }}</a>
                </li>
                <li>
                  <a href="/blogs">{{ $t("Articles") }}</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="md:w-2/5 pr-4 pl-4 pr-4 pl-4">
                            <div class="footer_item">
                                <ul>
                                    <li><a href="#">{{ $t('Facebook') }}</a></li>
                                    <li><a href="#">{{ $t('Instagram') }}</a></li>
                                    <li><a href="#">{{ $t('Twitter / X') }}</a></li>
                                    <li><a href="#">{{ $t('LinkedIn') }}</a></li>
                                </ul>
                            </div>
                        </div> -->
          <div class="md:w-1/5 pr-4 pl-4 self-end sm:pt-[6.4rem]">
            <div>
              <p class="text-[1.2rem] leading-[1.7]">
                {{
                  $t("© {year} Medkus. All rights reserved.", {
                    year: currentYear,
                  })
                }}
              </p>
              <p class="text-[1.1rem] leading-[1.7]">
                {{ $t("Medkus is a brand of {company}", { company: COMPANY.name }) }}
                · RFC {{ COMPANY.rfc }}
              </p>
              <p class="text-[1.1rem] leading-[1.7]">{{ COMPANY.address }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// ─── Sub-components ────────────────────────────────────────────────────────

import { defineComponent } from "vue";
import { COMPANY } from "@/constants/company";

export default defineComponent({
  name: "MarketFooter",
  data() {
    return { COMPANY };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
});
</script>

<style scoped>
.footer_item {
  @apply sm:pt-[3.2rem];
}

.footer_item ul li:not(:last-child) {
  @apply pb-[1.1rem];
}
.footer_item ul li a {
  @apply text-[1.2rem] leading-[1.7] hover:opacity-60;
}
</style>
